import { SpotlightSearch } from '@/shared/components/SpotlightSearch';
import { useLayoutStore } from '@/stores/layout-store';
import { AppSidebar } from './AppSidebar';
import { SidebarShell } from './SidebarShell';

/**
 * Team-scoped app shell — the shared {@link SidebarShell} with the team sidebar,
 * hosting the board / issue views via <Outlet/>, plus the ⌘K spotlight.
 */
export function AppShell() {
  const searchOpen = useLayoutStore((s) => s.searchOpen);
  const closeSearch = useLayoutStore((s) => s.closeSearch);

  return (
    <>
      <SidebarShell sidebar={<AppSidebar />} />
      <SpotlightSearch open={searchOpen} onClose={closeSearch} />
    </>
  );
}
